/* sv-motion-apply.js, 2026-10-11: gives every main page the homepage's motion style without editing each page body.
 * Runs deferred, after sv-rebuild.js and before sv-motion.js, and maps the theme's own markup to ARIA Motion
 * Standard primitives (data-m + a data-m-job per moving bit), then drops the theme's .sv-reveal class so one runtime
 * owns the motion. Nothing flashes: an element only loses .sv-reveal in the same step it gains a data-m that the
 * runtime's CSS hides until it enters. Pages that carry their own attributes (homepage, /pages/build) are skipped.
 * Rules, in order:
 *   1. .sv-label inside a revealed block types itself (typewrite)
 *   2. h1/h2 that reveal enter from the left (reveal-l), the reading direction
 *   3. a grid or flex row of revealed cards arrives together (stagger on the parent)
 *   4. every other .sv-reveal becomes reveal, keeping its --d1/--d2/--d3 delay
 *   5. the primary button pulls toward the pointer (magnetic); proof cards answer the pointer (tilt)
 *   6. the first hero-like section is marked data-m-hero for the gate and the X-ray */
(function () {
  'use strict';
  var b = document.body;
  if (!b || b.classList.contains('sv-page-index') || b.classList.contains('sv-page-page-build')) return;
  if (document.querySelector('main [data-m]:not([data-m="graphic"])')) return;   // a page that already declares its motion keeps it; a lone graphic piece (rule 8) still gets the style
  function all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function set(el, type, job, extra) {
    el.setAttribute('data-m', type); el.setAttribute('data-m-job', job);
    if (extra) Object.keys(extra).forEach(function (k) { el.setAttribute('data-m-' + k, extra[k]); });
  }
  function delayOf(el) { var m = /sv-reveal--d(\d)/.exec(el.className); return m ? (parseInt(m[1], 10) * 0.1).toFixed(1) : null; }
  function dropReveal(el) { el.classList.remove('sv-reveal', 'sv-reveal--d1', 'sv-reveal--d2', 'sv-reveal--d3'); el.classList.add('is-visible'); }

  /* 1. labels type themselves (only where the block around them is already hidden, so nothing flashes) */
  all('.sv-label').forEach(function (el) {
    if (el.closest('[data-m]') || !(el.classList.contains('sv-reveal') || el.closest('.sv-reveal'))) return;
    if (el.textContent.trim().length > 40) return;
    if (el.classList.contains('sv-reveal')) dropReveal(el);
    set(el, 'typewrite', 'section label types itself', { cps: 30 });
  });

  /* 2. titles enter from the left */
  all('h1.sv-reveal, h2.sv-reveal').forEach(function (el) {
    var d = delayOf(el); dropReveal(el);
    set(el, 'reveal-l', 'title enters from the left, the reading direction', d ? { dist: 56, dur: 1, delay: d } : { dist: 56, dur: 1 });
  });

  /* 3. rows of cards arrive together */
  var parents = [];
  all('.sv-reveal').forEach(function (el) { var p = el.parentElement; if (p && parents.indexOf(p) < 0) parents.push(p); });
  parents.forEach(function (p) {
    var kids = all(':scope > .sv-reveal', p);
    if (kids.length < 2 || kids.length !== p.children.length) return;
    var disp = getComputedStyle(p).display;
    if (disp !== 'grid' && disp !== 'flex') return;
    if (kids.some(function (k) { return /^H[1-6]$/.test(k.tagName) || k.classList.contains('sv-label'); })) return;
    kids.forEach(dropReveal);
    set(p, 'stagger', 'the cards arrive together: they belong to one set', { gap: 0.12, dist: 40, dur: 0.9 });
  });

  /* 4. everything else that revealed, reveals */
  all('.sv-reveal').forEach(function (el) {
    var d = delayOf(el); dropReveal(el);
    if (el.closest('[data-m="stagger"] > *')) return;
    set(el, 'reveal', 'reading order: the block arrives as you reach it', d ? { delay: d } : null);
  });

  /* 5. the one action pulls; proof cards answer the pointer */
  all('.sv-btn--primary').forEach(function (el) {
    if (el.closest('[data-m="magnetic"]') || el.closest('.sv-header, .sv-cart-drawer, .sv-mobile-buy-bar')) return;
    set(el, 'magnetic', 'pull toward the action', { radius: 50, strength: 0.25 });
  });
  all('.sv-intel-link, .sv-product-card, .sv-config-card, .sv-related__card, .sv-article-related a, .sv-intelhub-grid a').forEach(function (el) {
    if (el.getAttribute('data-m')) return;
    set(el, 'tilt', 'tactility: the card answers the pointer', { max: 4 });
  });

  /* 6. the first hero carries the hero mark */
  var hero = document.querySelector('main section[class*="-hero"], main .sv-hero, main section:first-of-type');
  if (hero && !document.querySelector('[data-m-hero]')) hero.setAttribute('data-m-hero', '');
})();
